import React, { StrictMode } from "react";
import ReactDOM from 'react-dom/client';
import App from "./App";
import { Provider } from "react-redux";
import reportWebVitals from "./reportWebVitals";
import { configureStore } from "./redux/store";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { DialogProvider } from "./DialogProvider";
// import { registerLocale } from "react-datepicker";
// import th from "date-fns/locale/th";

import './assets/scss/main.css?v=246';
// import './assets/scss/main2.scss??v=246';
import './assets/scss/custom-select.scss?v=246';

// dynamic inject google font
// const fontLink = document.createElement("link");
// fontLink.href = "https://fonts.googleapis.com/css2?family=Sarabun&display=swap";
// fontLink.rel = "stylesheet";
// document.head.appendChild(fontLink);

// In your main React file (like index.tsx or App.tsx)

// console.log('NODE_ENV = ' + process.env.NODE_ENV);



// registerLocale("th", th); 


const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

// Create a QueryClient instance
const queryClient = new QueryClient();

// navigator.serviceWorker.addEventListener('message', (event) => {
//   const { action, url } = event.data;

//   if (action === 'reloadOrNavigate') {
//       if (window.location.href === url) {
//           window.location.reload();
//       } else {
//           window.location.href = url;
//       }
//   }
// });

const onHello = () => {
  // window.location.href = 'https://chat9.2smetal.com/_uploadwp/2025/07/29/ca04ac20-2826-4798-9dca-06bc722ecde2/77/EmployeeLastDateConnectChat.xlsx';
  // window.location.href = "https://chat9_files.2smetal.com/file/_uploadwp/2025/07/29/ca04ac20-2826-4798-9dca-06bc722ecde2/77/EmployeeLastDateConnectChat.xlsx";
  // window.open("https://chat9_files.2smetal.com/file/_uploadwp/2025/07/29/ca04ac20-2826-4798-9dca-06bc722ecde2/77/EmployeeLastDateConnectChat.xlsx");
}

root.render(
  // <StrictMode>
    <Provider store={configureStore({})}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <DialogProvider>
            <App />
          </DialogProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </Provider>
  // </StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
